<template>
  <div id="cli_container" class="container-fluid h-100 overflow-auto" ref="cliContainer">
      <terminal-screen @needScroll="scrollToEnd"/>
      <div class="h-25"></div>
  </div>
</template>

<script>
import TerminalScreen from '../../components/Terminal/TerminalScreen'
import {
  mapActions
} from "vuex";
export default {
  components: {
    TerminalScreen
  },
  methods: {
    ...mapActions(["initFirstSession"]),
    scrollToEnd(){
      let container = this.$refs.cliContainer
      container.scrollTop = container.scrollHeight + 1000
    },
  },
  created(){
    this.initFirstSession()
  }
}
</script>

<style lang="scss">
</style>